import React, { useCallback, useEffect, useRef, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { videoInfoStore } from '../../../store/videoInfoStore';
import { isMobile } from "@pascal/pascal-core";
import { rouletteGame } from "../../../rouletteCanvas";

const innerHeight = window.innerHeight;
const innerWidth = window.innerWidth;
let offsetLeft = 0;
let offsetTop = 0;
let rect;

export const VideoPopUp = observer(() => {
  const [isFirst, setIsFirst] = useState(true);
  const [videoStyles, setVideoStyles] = useState({
    verticalPercent: `${(innerHeight / 2 * 100) / innerHeight}%`,
    horizontalPercent: `${(innerWidth / 2 * 40) / innerWidth}%`,
    transition: false,
  });

  const {
    isVideoOpen,
    isSmallWidth,
    setIsSmallWidth,
    setIsVideoOpen,
    isVideoAuto,
    setIsVideoVertical,
    isVideoVertical,
    setIsVideoAuto,
  } = videoInfoStore;
  const videoRef = useRef(null);

  const handleTouchStart = useCallback(e => {
    e.stopPropagation();
    rect = videoRef.current?.getBoundingClientRect();
    offsetLeft = e.targetTouches[0].pageX - rect.left;
    offsetTop = e.targetTouches[0].pageY - rect.top + rect.height;
    document.addEventListener('touchmove', handleTouchMove);
  }, [isSmallWidth]);

  const handleTouchMove = useCallback(e => {
    setIsFirst(false)
    e.stopPropagation();
    const parentHeight = videoRef.current.parentElement.clientHeight;
    const parentWidth = videoRef.current.parentElement.clientWidth;
    const { pageY, pageX } = e.targetTouches[0];
    const changeYAxis = pageY - offsetTop;
    const changeXAxis = pageX - offsetLeft;
    if ((changeYAxis + rect.height + 100 > parentHeight) || (Math.abs(
      changeYAxis) + 100 > rect.height && changeYAxis < 0)) {
      e.preventDefault();
    } else {
      if (isSmallWidth && ((changeXAxis + rect.width > parentWidth) || changeXAxis < 0)) {
        e.preventDefault();
      } else {
        setVideoStyles({
          verticalPercent: changeYAxis + `px`,
          transition: false,
          horizontalPercent: changeXAxis + 'px',
        });
      }
    }
  }, [isSmallWidth]);


  const handleTouchEnd = useCallback(e => {
    e.stopPropagation();
    setVideoStyles(prevState => ({ ...prevState, transition: false }));
    document.removeEventListener('touchmove', handleTouchMove);
  }, [isSmallWidth]);

  useEffect(() => {
    return () => {
      setIsVideoAuto(true);
      setIsVideoVertical(false);
    };
  }, []);

  // useEffect(() => {
  //   rouletteGame();
  // }, []);

  return (
    <>
      <div ref={videoRef} onTouchStart={isVideoOpen ? handleTouchStart : null} onTouchEnd={handleTouchEnd}
           style={isVideoOpen && !isFirst ? isSmallWidth && !isFirst ? {
             top: `${videoStyles.verticalPercent}`,
             bottom: 'unset',
             transition: videoStyles.transition ? 'none' : '',
             left: `${videoStyles.horizontalPercent}`,
           } : {
             top: `${videoStyles.verticalPercent}`, bottom: 'unset', transition: videoStyles.transition ? 'none' : '',
           } : null}
           className={`bet-container-small-video ${isVideoOpen ? isSmallWidth ? 'normal' : 'large' : ''}`}
           onClick={() => !isVideoOpen && setIsVideoOpen(true)}> {/*add/remove class large/normal*/}
        {/*<RouletteAnimation/>*/}
        <canvas id={'roulette-canvas'}
                width={isMobile() ? 640 : 1920}
                height={isMobile() ? 360 : 1080}
        ></canvas>
        <div className="bet-c-can-icon-wrp">
          <i className="icon-arrow-down1" onClick={(e) => {
            e.stopPropagation();
            setIsVideoOpen(!isVideoOpen);
          }}/>
          <i className="icon-minimize" onClick={(e) => {
            if (isVideoOpen) {
              e.stopPropagation();
              setIsSmallWidth(!isSmallWidth);
            }
          }}/>
        </div>
        <div className={`b-c-video-icon ${isVideoAuto ? '' : isVideoVertical ? 'type-2' : 'type-1'}`}
        ><i
          className="icon-video-a" onClick={() => {
          if (isVideoOpen) {
            if (isVideoAuto) {
              setIsVideoAuto(false);
              setIsVideoVertical(true);
              // loadThree.camera1();
            } else if (isVideoVertical) {
              setIsVideoVertical(false);
              // loadThree.camera2();
            } else {
              setIsVideoAuto(true);
            }
          }
        }}/></div>
      </div>
    </>
  );
});
